import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import "../styles/About.css";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    // Split the text into words
    const splitText = new SplitType(".fade-text", { types: "words, chars" });

    const chars = splitText.chars;

    // Pin the section while scrolling through the text
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "+=100%",
      pin: true,
      scrub: true,
    });

    // Animate characters smoothly as they scroll
    gsap.fromTo(
      chars,
      { opacity: 0.3, color: "rgb(180, 180, 180)" }, // Start faded
      {
        opacity: 1,
        color: "#000",
        stagger: { each: 0.02, from: "start" }, // Fixed stagger placement
        scrollTrigger: {
          trigger: section,
          start: "top 10%",
          end: "bottom top",
          scrub: true,
        },
      },
    );
  }, []);

  return (
    <section id="about" className="about-section" ref={sectionRef}>
      <div className="sticky-container">
        <section className="reveal-type">
          <h2 className="first-title fade-text">
            Why Choose <br /> Auto DrivR School?
          </h2>

          <p className="choose-paragraph fade-text">
            At Auto DrivR School, <strong>Aman</strong>, a certified instructor
            specialising in{" "}
            <strong>automatic and manual driving lessons</strong> ensures
            supportive experience tailored to your needs. Whether you're a
            nervous beginner or refining your skills, Aman’s expertise helps you
            become a <strong>confident driver</strong>.
          </p>
        </section>
      </div>
    </section>
  );
};

export default About;
